import axios from "axios";

const state = {
  quantityCalls: 0,
  quantityReviews: 0,
  quantityComments: 0,
}

const mutations = {
  setQuentityCalls(state, payload) {
    state.quantityCalls = payload
  },
  setQuentityReviews(state, payload) {
    state.quantityReviews = payload
  },
  setQuentityComments(state, payload) {
    state.quantityComments = payload
  }
}

const actions = {
  async fetchQuentityCalls({ commit }) {
    await axios.get('/request-call/quantity')
      .then((response) => commit('setQuentityCalls', response?.data?.requests_quantity || 0))
      .catch(() => commit('setCatalogSections', 0));
  },
  async fetchQuentityReviews({ commit }) {
    await axios.get('/review/no-checked-quantity')
      .then((response) => commit('setQuentityReviews', response?.data?.reviews_quantity || 0))
      .catch(() => commit('setQuentityReviews', 0));
  },
  async fetchQuentityComments({ commit }) {
    await axios.get('/comment/no-checked-quantity')
      .then((response) => {
        commit('setQuentityComments', response.data.comments_quantity || 0)
      })
      .catch(() => commit('setQuentityComments', 0));
  },
  async updateQuentityCalls() {
    this.fetchQuentityCalls()
  },
  async updateQuentityReviews() {
    this.fetchQuentityReviews()
  }
}

export default {
  state,
  mutations,
  actions,
}